import React from "react";
import { useDispatch } from "react-redux";
import { Icon } from "rhombus-react";
import classNames from "classnames";

import { confirmPreviews } from "reducers/Confirm";
import {
	deleteCreativePreview,
	extendCreativePreview,
	makeCreativePreviewPermanent
} from 'reducers/CreativePreviews';
import { openModal } from 'reducers/Modal';
import { MODAL_TYPES, TIA_DOMAIN } from 'utils/constants';
import { capFirst } from "utils/common";

import "./PreviewActions.css";

export function PreviewActions(props){
	let dispatch = useDispatch()
		, { libraryId, id, previewName, isPermanent, type, status } = props.dependentValues
		, isMockup = type === "mockup"
		, typeName = isMockup ? "mockup" : "preview"
		, permanentClasses = classNames({ "is-disabled": isPermanent, 'bounce-circle': true })
		, notSharedTip = "Mockup is not shared"
		, extendTip = ""
		, permanentTip = ""
		, deleteTip = `Delete ${typeName}`
		;

	if (status === "not_shared") {
		extendTip = notSharedTip;
		permanentTip = notSharedTip;
	} else if (isPermanent) {
		extendTip = `${capFirst(typeName)} is permanent`;
		permanentTip = `${capFirst(typeName)} is already permanent`;
	} else {
		extendTip = `Extend ${typeName} 90 days`;
		permanentTip = `Make ${typeName} permanent`;
	}

	function deletePreview() {
		return dispatch(confirmPreviews(deleteCreativePreview, {
			libraryId,
			previews: [{ id, type, name: previewName, status }],
			title: "Delete Preview",
			desc: `Are you sure you want to delete the following shared preview?`,
			commitTheme: "red",
		}));
	}

	function extendPreview() {
		if (isPermanent) {
			return;
		}
		return dispatch(confirmPreviews(extendCreativePreview, {
			libraryId,
			previews: [{ id, type, name: previewName, isPermanent, status }],
			commitLabel: "Extend 90 Days",
			title: "Confirm Extending Preview 90 Days",
			desc: `Are you sure you want to update the expiry date of the following shared preview to 90 days from now?`,
			commitTheme: "blue",
		}, true));
	}

	function makePermanent() {
		if (isPermanent) {
			return;
		}
		return dispatch(confirmPreviews(makeCreativePreviewPermanent, {
			libraryId,
			previews: [{ id, type, name: previewName, isPermanent: true, status }],
			title: "Confirm Making Preview Permanent",
			commitLabel: "Make Permanent",
			desc: `Are you sure you want to make the following shared preview permanent?`,
			commitTheme: "blue",
		}, true));
	}

	function getLinkedCreatives() {
		return dispatch(openModal(MODAL_TYPES.PREVIEW_LINKED_CREATTIVES, props.dependentValues));
	}


	return (
		<div className="grid-actions preview-actions flex-center">
			<Icon data-tip={extendTip} name="far fa-alarm-snooze" className={permanentClasses} onClick={extendPreview} />
			<Icon data-tip={permanentTip} name="far fa-infinity" className={permanentClasses} onClick={makePermanent} />
			<Icon data-tip="View linked creatives" name="far fa-list" className="bounce-circle" onClick={getLinkedCreatives} />
			{ isMockup && <a
				href={`${TIA_DOMAIN}/mockup/${libraryId}/${previewName}/edit`}
				target="_blank">
				<Icon data-tip="Edit mockup" name="far fa-pencil" className="bounce-circle" />
			</a> }
			<Icon data-tip={deleteTip} name="far fa-trash-alt" className="bounce-circle" onClick={deletePreview} />
		</div>
	);
}

const PreviewActionsCell = {
	key: "actions",
	name: "Actions",
	cellClass: "actions-cell",
	width: 150,
	formatter: PreviewActions,
	resizable: false,
	sortable: false,
	getRowMetaData: getActionMetadata,
};

function getActionMetadata(data) {
	let extraInfo = {
		id: data.id,
		libraryId: data.libraryId,
		previewName: data.name,
		versionsPreviewUrl: data.publicUrlVV,
		creativePreviewUrl: data.publicUrlTiA,
		dateCreated: data.dateCreated,
		dateExpires: data.dateExpires,
		disabled: data.disabled,
		isPermanent: data.isPermanent,
		type: data.type,
		status: data.status,
	};

	return extraInfo;
}

export default PreviewActionsCell;
